var map = {
	"./bg_alternate-login.svg": "4b36",
	"./bg_home.svg": "42fa",
	"./bg_login-mobile.svg": "5949",
	"./bg_login.svg": "0035",
	"./imersys.svg": "26e0",
	"./logo_sagah.svg": "af52",
	"./v-chip.svg": "6c02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edbe";